import { defineComponent, computed } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
const _sfc_main = defineComponent({
  name: "VaListItemLabel",
  props: {
    ...useComponentPresetProp,
    caption: { type: Boolean, default: false },
    lines: { type: Number, default: 1 }
  },
  setup: (props) => ({
    computedClass: computed(() => ({ "va-list-item-label--caption": props.caption })),
    computedStyle: computed(() => ({ "-webkit-line-clamp": props.lines }))
  })
});
export {
  _sfc_main as _
};

import '../../../VaListItemLabel.css';
//# sourceMappingURL=VaListItemLabel.vue_vue_type_script_lang-6988f959.mjs.map
